import { router } from '@inertiajs/react'
import { useEffect } from 'react'
import { getLocale } from '~/lib/i18n'

// Keeps the t() dictionary in step with the server across Inertia visits.
// Inertia navigations are XHR page swaps, not document loads — so a visit
// can land with a different shared `locale` prop (the switcher, entering a
// Dutch child's desk, leaving through the gate). A language change deserves
// document-load semantics: reload, so the entrypoint reboots the dictionary
// (and <html lang>) in the arriving locale. Remount tricks are traps here —
// re-keying Inertia's <App> resets it to its boot-time initialPage, and a
// plain parent re-render bails out on the unchanged children element.
//
// `reload` is injectable because jsdom's window.location.reload cannot be
// stubbed.
export function LocaleSync({ reload = () => window.location.reload() }: { reload?: () => void }) {
  useEffect(
    () =>
      router.on('navigate', (event) => {
        const next = (event.detail.page.props as { locale?: string }).locale
        if (next && next !== getLocale()) reload()
      }),
    [reload]
  )

  return null
}
